/**
 * Widget de démonstration du tutoriel : un vrai WeatherWidget (en mode preview,
 * données mock, sans appel réseau) dont la taille s'anime. En grandissant, il
 * révèle des informations supplémentaires (métriques, prévisions horaires/journalières)
 * invisibles quand il est petit — c'est ce que la démo illustre.
 */
import { WeatherWidget } from "../widgets/WeatherWidget";
import { WidgetPreviewContext } from "../widgets/WidgetShell";

export function FakeWidget({ running }: { running: boolean }) {
  return (
    <div className={`tutorial-fake-widget ${running ? "is-running" : ""}`}>
      <WidgetPreviewContext.Provider value={true}>
        {/* Pas de latitude/longitude → le widget utilise ses données de démo. */}
        <WeatherWidget locationName="Lanester" />
      </WidgetPreviewContext.Provider>

      {/* Poignée de redimensionnement (même look que sur le dashboard). */}
      <span className="tutorial-fake-handle">
        <span className="tutorial-fake-handle-grip" />
      </span>
    </div>
  );
}
